"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteCirrusStorePath = void 0;
const react_1 = require("react");
const contexts_1 = require("../contexts");
function useSiteCirrusStorePath() {
    const { id } = react_1.useContext(contexts_1.SiteContext);
    if (!id) {
        throw new Error('Unknown site type. Please use LocationProvider or ProspectProvider.');
    }
    if (id.type === 'location') {
        return `yanzi://location/${id.locationId}`;
    }
    if (id.type === 'prospect') {
        return `yanzi://account/${id.accountNumber}/prospects/${id.prospectId}`;
    }
    throw new Error('Unknown site type. Please use LocationProvider or ProspectProvider.');
}
exports.useSiteCirrusStorePath = useSiteCirrusStorePath;
//# sourceMappingURL=useSiteCirrusStorePath.js.map